import flatten from 'flat';

export default flatten({
  insights: {
    disclaimer: "BEEM AI Assistant chats aren't used to train AI models. BEEM AI can make mistakes.",
    headerImg: 'BEEM AI Assistant header image',
    headerTitle: 'Que voulez-vous faire ?',
    // The title cycles through these verbs, one per sweep of its gradient (EmptyState.tsx).
    headerTitleVerb: 'Que voulez-vous {verb} ?',
    headerVerbs: 'faire|savoir|voir|créer|construire',
    headerSubtitle:
      'Discover how to uncover valuable insights from your company data by leveraging AI.',
    info1: 'None of your datasets are currently marked as searchable by BEEM AI.',
    info2: 'Follow the quick and easy steps below to start enjoying the power of AI and your data.',
    onboardingStep1Title: 'Add quality descriptions to your datasets',
    onboardingStep1Text:
      'To get the most out of the AI Assistant, add descriptions to your datasets that express what they contain and explain how to use the data. Navigate to a dataset, inside the editor view and add descriptions from the Documentation panel.',
    onboardingStep2Title: 'Mark your datasets as searchable',
    onboardingStep2Text:
      'In order for BEEM AI to give the most accurate answer to your questions, only marked datasets will be taken into account to generate insights. In the Documentation panel of each dataset, toggle on the searchable option.',
    onboardingStep3Title: 'Ask BEEM AI for insights about your data',
    onboardingStep3Text:
      'Uncover the best insights buried deep inside your datasets by asking the BEEM AI questions.',
    configure: 'Configure My Datasets',
    Chat: {
      placeholder: 'Posez une question, ou dites quoi construire',
      copyLink: 'Copier le lien vers cette conversation',
      linkCopied: 'Lien copié',
      linkCopyFailed: 'Impossible de copier le lien',
      placeholderFollowUp: 'Continue refining your question',
      retry: 'Réessayer',
      stop: 'Arrêter',
      inputPlaceholder: 'Type here to chat',
      copy: 'Copy',
      assistantName: 'Robot',
      yourName: 'You',
      send: 'Send',
      roleYou: 'Vous',
      shareConversation: 'Partager',
      shared: 'Partagée',
      visibilityManagedByProject: 'La visibilité est gérée par le projet de cette conversation.',
      onlyOwnerCanShare: 'Seul le propriétaire ({name}) peut partager cette conversation.',
      shareConversationSuccess: 'Conversation partagée avec votre espace de travail',
      sharingOff: 'Partage désactivé',
      error: 'There was an error loading the chat messages.',
      disclaimer:
        'The BEEM AI Assistant answers questions leveraging the data contained in the marked datasets of this workspace only.',
      datasetCount:
        '{datasetCount, plural, one {# Dataset} other {# Datasets}} will be accessible by BEEM AI in this conversation.',
      datasetsPopoverTitle: 'Jeux de données utilisables par BEEM AI',
      selectAllDatasets: 'Tout sélectionner',
      deselectAllDatasets: 'Tout désélectionner',
      showDescription: 'Voir la description',
      datasets: 'Jeux de données',
      noDatasets: 'Aucun jeu de données disponible',
      hideRail: 'Masquer le panneau',
      showRail: 'Afficher les détails de la conversation',
      conversationDetails: 'Détails de la conversation',
      voiceStart: "Posez votre question à l'oral",
      voiceStop: "Arrêter l'enregistrement",
      voiceComingSoon: 'Saisie vocale bientôt disponible',
    },
    loading: {
      dashboard: 'On lance votre tableau de bord',
      dashboardRead: 'Lecture du tableau de bord',
      monitoring: 'Lecture des événements de surveillance',
      dataset: 'Lecture du jeu de données',
      datasetFix: 'On teste le nouveau SQL',
      dashboardWrite: 'Écriture du tableau de bord',
      dashboardCards: 'Mise à jour des cartes sélectionnées',
      datasetTest: "On essaie le test sur les données d'aujourd'hui",
      source: 'On cherche la source',
      starting: 'On démarre',
      recalling: 'On rappelle ce que je sais de vous',
      thinking: 'On réfléchit',
      runningQuery: 'On interroge vos données',
      browsing: 'Lecture de {site}',
      analyzing: 'On parcourt vos données',
      querying: 'On cherche la réponse',
      sampling: 'On regarde du côté de {datasetName}',
      interpreting: 'On met tout en forme',
    },
    suggest: {
      label: 'Suggestions pour vos données',
      loading: 'Génération de suggestions à partir de vos données',
      refresh: 'Régénérer les suggestions',
      aboutTitle: 'À propos de {datasetName}',
      aboutDesc: 'À quoi il sert, avec quelques constats intéressants',
      summaryTitle: 'Résumer {datasetName}',
      summaryDesc: 'Un aperçu rapide et global des données',
      topValuesTitle: 'Valeurs les plus fréquentes dans {datasetName}',
      topValuesDesc: 'Les valeurs qui reviennent le plus souvent',
    },
    showQuery: 'Show Query',
    showData: 'Show Data',
    copyAnswer: 'Copier la réponse',
    thumbsDown: 'Mauvaise réponse',
    feedbackNoted: 'Merci pour votre retour',
    feedback: {
      title: "Qu'est-ce qui n'allait pas ?",
      incorrect: 'Réponse incorrecte',
      notFollowed: 'Demande non respectée',
      bug: 'Un problème est survenu (bogue)',
      notePlaceholder: 'Ajoutez un détail (facultatif)…',
      submit: 'Envoyer',
      thanks: 'Merci — signalé pour examen.',
      disclaimer:
        "Pour nous aider à l'analyser, votre question et votre commentaire sont transmis à l'équipe BEEM, avec des détails techniques sur cette réponse. La réponse elle-même et vos données ne sont pas transmises.",
    },
    export: 'Télécharger',
    exportCsv: 'Exporter en CSV',
    exportPdf: 'Exporter en PDF',
    beta: 'BETA',
    close: 'Fermer',
    createdBy: 'Créée par {name}',
    ownedBy: 'Détenue par {name}',
    download: {
      title: 'Télécharger la conversation',
      subtitle: 'Choisissez un format de téléchargement.',
      zipOption: 'Tableaux de données + transcription',
      zipDesc: 'Le tableau de chaque réponse en feuille de calcul (CSV), plus le texte de la conversation, dans un .zip.',
      pdfOption: 'Document PDF',
      pdfDesc: 'Toute la conversation en PDF imprimable, tableaux inclus.',
    },
    home: {
      recent: 'Conversations récentes',
    },
    panelCta: {
      monitor: "Qu'est-ce qui a échoué récemment, et pourquoi ?",
      dashboard: 'Aide-moi à analyser ce tableau de bord',
      dataset: 'Explique ce que contient ce jeu de données',
      dataObject: 'Résume ces données',
      flow: 'Explique ce que fait ce flux',
      generic: 'Que peux-tu me dire sur ce que je consulte ?',
    },
    tools: {
      dashboard: 'Tableau de bord',
      dashboardRead: 'Tableau de bord lu',
      openDashboard: 'Ouvrir le tableau de bord',
      dashboardBuilding: 'En cours de création, quelques minutes en général',
      dashboardReady: 'Prêt',
      dashboardFailed: "La génération a échoué, ouvrez-le pour voir pourquoi",
      monitor: 'Événements de surveillance',
      monitorReading: 'Lecture des événements de surveillance',
      monitorRead: '{count, plural, one {# événement lu} other {# événements lus}}',
      dataset: 'Jeu de données',
      datasetRead: '{name} lu',
      datasetFix: 'SQL proposé',
      datasetFixTested: 'Testé, {count, plural, one {# colonne} other {# colonnes}}',
      reviewFix: "Revoir dans l'éditeur",
      reviewNew: 'Créer le jeu de données',
      fixHint: "Pas encore enregistré : vous le revoyez et le déployez",
      datasetTest: 'Test proposé',
      testPassesToday: "réussit aujourd'hui",
      testFailsToday: "échoue aujourd'hui",
      testHintPasses: "Test sur {dataset}. Réussit sur les données d'aujourd'hui.",
      testHintFails: "Test sur {dataset}. Échoue sur les données d'aujourd'hui : ses prochains résultats seraient bloqués.",
      connectedBackToChat: 'Source connectée. Ses données arrivent après la première synchronisation.',
      connectedFollowUp: "J'ai connecté {name}. Qu'est-ce qu'on peut en faire ?",
      theSource: 'la source',
      backToChat: 'On termine la connexion, puis retour à votre conversation…',
      page: 'Tableau de bord enregistré',
      pageProblems: '{count, plural, one {# problème à corriger} other {# problèmes à corriger}}',
      createTest: 'Créer le test',
      newDatasetHint: 'Créé et déployé au clic, dans Jeux de données sous AI Assistant',
      reviewFirst: "Le revoir d'abord",
      creatingDataset: 'Création…',
      openDataset: 'Ouvrir le jeu de données',
      datasetStage: {
        creating: 'Création du jeu de données',
        deploying: "Déploiement dans l'entrepôt",
        running: 'Déployé, premier rafraîchissement en cours',
        ready: 'Prêt, premier rafraîchissement terminé',
        readyCounts:
          'Prêt, premier rafraîchissement terminé : {rows, plural, one {# ligne} other {# lignes}}, {columns, plural, one {# colonne} other {# colonnes}}',
        failed: 'Le premier rafraîchissement a échoué, ouvrez-le pour voir pourquoi',
        draft: "Enregistré comme brouillon : revoyez-le et déployez-le dans l'éditeur",
      },
      creatingTest: 'Création…',
      source: 'Source',
      connect: 'Connecter {name}',
      connectHint: "Ouvre la configuration pour autoriser l'accès. Les données arrivent après la première synchronisation.",
    },
    source: {
      createdBy: "Créé par l'Assistant IA",
      openConversation: 'Ouvrir la conversation',
    },
    dashboardChat: {
      empty: "Dites ce que ce tableau de bord doit montrer, ou sélectionnez des cartes et dites quoi changer.",
      placeholder: 'Décrivez ce qu’il faut construire ou changer…',
      readOnly: "Pour l'instant, seul le créateur de ce tableau de bord peut le modifier avec l'IA. Vous pouvez toujours le consulter et poser vos questions à l'Assistant IA.",
    },
    context: {
      monitor: 'Surveillance',
      datalake: 'Lac de données',
      warehouse: 'Entrepôt',
      dashboard: 'Tableau de bord',
      aiDashboard: 'Tableau de bord IA',
      flows: 'Flux',
      home: 'Accueil',
      settings: 'Paramètres',
      other: 'Panneau',
    },
    panel: {
      earlierHere: 'Plus tôt ici',
    },
    memory: {
      open: 'Mémoire',
      title: 'Mémoire',
      intro:
        "BEEM AI retient des faits et des préférences de vos conversations dans cet espace de travail, ainsi qu'un court résumé de chacune, pour mieux vous répondre la prochaine fois. Vous seul pouvez les voir. En supprimer un n'empêche pas qu'il soit retenu de nouveau s'il revient dans une conversation.",
      notesHint: 'Indiquez à BEEM AI ce qu\'il doit garder en tête dans chaque conversation.',
      stepLabel: 'Mémoire',
      recalled: 'Éléments retenus à votre sujet et possiblement pertinents : {count}.',
      seeWhat: 'Voir ce que je retiens',
      disabled: "La mémoire n'est pas encore activée pour cet espace de travail.",
      loadError: "Impossible de charger ce que BEEM AI retient. Veuillez réessayer.",
      saveError: "Votre modification n'a pas été enregistrée. Veuillez réessayer.",
      addError: "Cela n'a pas été ajouté à la mémoire. Veuillez réessayer.",
      addPlaceholder: 'Retiens que…',
      add: 'Ajouter',
      empty: "Rien n'est retenu pour le moment.",
      edit: 'Modifier',
      delete: 'Supprimer',
      save: 'Enregistrer',
      cancel: 'Annuler',
      loadMore: 'Afficher plus',
      forgetAll: 'Tout oublier',
      forgetAllTitle: 'Tout oublier ?',
      forgetAllBody:
        "BEEM AI effacera {facts, plural, one {# fait} other {# faits}}, {preferences, plural, one {# préférence} other {# préférences}}, {sessions, plural, one {# résumé de conversation} other {# résumés de conversation}} et {notes, plural, one {# note} other {# notes}} qu'il garde sur vous dans cet espace de travail. Vos conversations sont conservées. Cette action est irréversible.",
      forgetAllConfirm: 'Tapez {word} pour confirmer',
      forgetAllInProgress: "Suppression en cours. L'opération peut prendre quelques minutes.",
      kind: {
        all: 'Tout',
        facts: 'Faits',
        preferences: 'Préférences',
        sessions: 'Conversations',
        notes: 'Vos notes',
      },
    },
    history: {
      title: 'Conversations',
      new: 'Nouvelle conversation',
      rename: 'Renommer',
      delete: 'Supprimer cette conversation ?',
      deleteBody:
        'Cette conversation et tous ses messages seront définitivement supprimés. Cette action est irréversible.',
      empty: 'Aucune conversation pour le moment',
      sharedSection: "Partagées à l'espace de travail",
      recentSection: 'Récentes',
      sharedWithYou: 'Partagé avec vous',
      stopSharing: 'Ne plus partager',
      deleteAction: 'Supprimer',
      projectsSection: 'Projets',
      newProject: 'Nouveau projet',
      moveToProject: 'Déplacer vers un projet',
      moveBody:
        'Déplacez cette conversation dans un projet. Elle héritera des jeux de données par défaut et de la visibilité du projet.',
      move: 'Déplacer',
      removeFromProject: 'Retirer du projet',
      searchConversations: 'Rechercher des conversations',
      searchProjects: 'Rechercher des projets',
    },
    project: {
      createTitle: 'Nouveau projet',
      editTitle: 'Modifier le projet',
      untitled: 'Projet sans titre',
      makePublic: 'Rendre public',
      makePrivate: 'Rendre privé',
      name: 'Nom du projet',
      namePlaceholder: 'ex. Prévisions T3',
      description: 'Description',
      descriptionPlaceholder: 'De quoi parle ce projet ?',
      instructions: 'Instructions personnalisées',
      instructionsPlaceholder: 'Contexte que chaque conversation de ce projet devrait utiliser…',
      datasets: 'Jeux de données par défaut',
      create: 'Créer le projet',
      save: 'Enregistrer',
      usingContext: 'Contexte du projet appliqué',
      usingContextAndDatasets: 'Utilise le contexte et les jeux de données définis par ce projet',
      settings: 'Paramètres du projet',
      details: 'Détails du projet',
      edit: 'Modifier les paramètres du projet',
      conversations: 'Conversations',
      empty: 'Aucune conversation — démarrez-en une ci-dessous.',
      noProjects: 'Aucun projet pour le moment',
      ask: 'Posez une question sur ce projet…',
      delete: 'Supprimer le projet',
      deleteConfirm: 'Supprimer ce projet ?',
      deleteConfirmBody: 'Ses conversations seront conservées et retirées de ce projet.',
      datasetCount: '{count, plural, =0 {Aucun jeu de données par défaut} one {# jeu de données par défaut} other {# jeux de données par défaut}}',
      noInstructions: 'Aucune instruction personnalisée',
      commonPromptPlaceholder: 'Décrivez ce projet et les instructions que chaque conversation doit suivre…',
      noPrompt: 'Aucune description pour le moment',
      noKnowledge: 'Aucune connaissance ajoutée pour le moment',
      knowledge: 'Connaissances',
      knowledgePlaceholder: 'Documents de référence fournis aux conversations démarrées dans ce projet…',
      visibility: 'Visibilité',
      private: 'Privé',
      privateDesc: 'Vous seul pouvez voir et utiliser ce projet.',
      public: 'Public',
      publicDesc: "Tous les membres de l'espace de travail peuvent voir et modifier ce projet.",
      visibilityPermanent:
        'La visibilité est permanente — elle <b>NE PEUT PAS</b> être modifiée après la création du projet.',
    },
    share: {
      title: 'Partager la conversation',
      subtitle:
        "Cette conversation sera partagée avec tout votre espace de travail. Vous pouvez aussi choisir des personnes ci-dessous pour leur envoyer une notification par courriel — ou simplement Partager.",
      tabMembers: "Membres de l'espace",
      tabInvite: "Inviter dans l'espace",
      searchMembers: 'Rechercher des membres',
      notifying: 'Notifié',
      noMembers: 'Aucun membre à notifier',
      enterEmail: 'Saisissez les courriels des nouveaux utilisateurs',
      inviteWarning:
        "Confirmer invitera {count, plural, one {# utilisateur externe} other {# utilisateurs externes}} dans cet espace de travail.",
      alreadyMembers: 'Déjà dans cet espace : {emails}',
      fixEmails: 'Veuillez corriger les champs de courriel.',
      cancel: 'Annuler',
      notify: 'Notifier',
      confirm: 'Partager',
      success: 'Conversation partagée',
      stopConfirm: 'Arrêter de partager cette conversation ?',
      stopConfirmBody:
        "Cette conversation ne sera plus visible par votre espace de travail. Vous pourrez la repartager à tout moment.",
    },
  },
});
